import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteAAccount, loadAccountsData, saveAAccount, updateAAccount} from "../../redux/modules/account";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        color:"black",
    },
});


class BankAccount extends React.Component {


    state = {

        //selectedLocation:{},
        selectedAccount:{},
        inputFieldShrinkState:true,
        numberShrink:false  //Jut sfor alter I can add a shrink flag for each filed. 

    };
    
    /*
    
    private String id;
	private String accountName;
	private String accountNumber;
	private String bankName;
	private String address1;
	private String address2;
	private String city;
	private String state;
	private String country;
	private String zipCode;
	private String accountRoutingNumber;
	private String companyId;
	private String userId;
	private String phone;
    
     */

    constructor(props) {
        super(props);
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleAccountNumberChange = this.handleAccountNumberChange.bind(this);
        this.handleAccountNameChange = this.handleAccountNameChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleBankNameChange = this.handleBankNameChange.bind(this);

        this.handleAddress2Change = this.handleAddress2Change.bind(this);

        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleAccountRoutingChange = this.handleAccountRoutingChange.bind(this);


    }


    handleSubmit () {


        let { saveAAccount } = this.props;

        var tempStream = this.state.selectedAccount ;
        tempStream.locationId= this.state.selectedLocation.id;
        saveAAccount(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleUpdate () {
        let { updateAAccount } = this.props;

        var tempStream = this.state.selectedAccount ;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateAAccount(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{zipCode:event.target.value}));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{country:event.target.value}));
    }

    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{state:event.target.value}));
    }


    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{city:event.target.value}));
    }

    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{address2:event.target.value}));
    }

    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{address1:event.target.value}));
    }

    handleAccountNumberChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{firstName:event.target.value}));
    }


    handleBankNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{bankName:event.target.value}));
    }

    handleAccountNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{accountName:event.target.value}));
    }

    handleAccountRoutingChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{accountRoutingNumber:event.target.value}));
    }

    handleNumberChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedAccount,{accountNumber:event.target.value}));
        this.setState({numberShrink:true});
    }

    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }


    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));


        var tempSelectedAccount =   Object.assign({}, this.state.selectedAccount);
        Object.keys(tempSelectedAccount).map((key, index) => {
            tempSelectedAccount[key] = "" ;
        });
        this.setState({selectedAccount:tempSelectedAccount})




    };
    renderErrorFiled(data){


    }

    refresh(event) {
        let { loadAccountsData } = this.props;
        loadAccountsData(DEFAULT_VESPAAN_SERVER.url );
    }


    render() {
        const {classes} = this.props;
        return (
        <React.Fragment>
        <Typography variant="h6" gutterBottom>
            Bank Account Information
        </Typography>
    <Grid container spacing={24}>

        <Grid item xs={12} sm={12}>
            {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedAccount.accountNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.accountName} onChange={this.handleAccountNameChange}/>
                </Grid>
            </Grid>
        <Grid container >
        <Grid item xs={5} sm={5}>
            <TextField  required id="bankname" name="bankname" label="Bank Name"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.bankName} onChange={this.handleBankNameChange}  />
        </Grid>
        <Grid item xs={2} sm={2} >
            </Grid>
            <Grid item xs={5} sm={5} >
            <TextField required id="routing" name="routing"  label="Routing Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.accountRoutingNumber} onChange={this.handleAccountRoutingChange}/>
        </Grid>
        </Grid>

                <Grid item xs={12}>
                    <TextField  required id="address1" name="address1" label="Address line 1"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.address1} onChange={this.handleAddress1Change}  />
                </Grid>
                <Grid item xs={12}>
                    <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.address2} onChange={this.handleAddress2Change} />
                </Grid>
                <Grid container >
                        <Grid item xs={5} sm={5} >
                            <TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.city} onChange={this.handleCityChange}/>
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>
                        <Grid item xs={5} sm={5} >
                            <TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.state} onChange={this.handleStateChange}/>
                        </Grid>
                        <Grid item xs={5} sm={5}>
                            <TextField  required  id="zip"  name="zip"  label="Zip / Postal code"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.zipCode} onChange={this.handleZipcodeChange}  />
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>
                        <Grid item xs={5} sm={5}>
                            <TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.country} onChange={this.handleCountryChange} />
                        </Grid>

                        <Grid item xs={5} sm={5}>
                            <TextField  required id="phone"  name="phone"  label="Bank Phone"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedAccount.phone} onChange={this.handlePhoneChange} />
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>


                </Grid>

                <Grid container >

                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                        Add Bank Account
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                        Update Bank Account
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                        Clear Fields
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                        Refresh
                        </Button>
                    </Grid>
                </Grid>
                <Grid container >
                     {  this.props.errorCMsg && (
                        <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>)
                    }
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <DynamicTable  data={this.props.accountsArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable>
                </Grid>

            </Grid>
        </React.Fragment>
    );
    }//end of render



    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedAccount:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );

        //this.setState({selectedLocation:tempLocation });

    }


    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteAAccount } = this.props;
        deleteAAccount(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }


    componentWillMount(){
        let { loadAccountsData , loadLocationsData } = this.props;
        loadAccountsData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );

            this.setState({
                errorCMsg:{}
            });


    }

    componentWillReceiveProps(nextProps) {
        if (this.props.accountsArray !== nextProps.accountsArray) {
            this.setState({
                accountsArray: nextProps.accountsArray
            });
        }
    }



}//end of class

BankAccount.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        accountsArray: state.account.accountsArray,
        AccountDeleteResponse:state.account.deleteAccountResp,
        AccountSaveResponse:state.account.saveAccountResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.account.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadAccountsData:loadAccountsData,
        deleteAAccount:deleteAAccount,
        saveAAccount:saveAAccount,
        updateAAccount:updateAAccount,

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BankAccount));
